import { createApi } from '@reduxjs/toolkit/query/react';
import customBaseQuery from '@/lib/customBaseQuery';

const notificationsBaseUrl = '/api/notifications';
export const notificationsApi = createApi({
  reducerPath: 'notificationsApi',
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    forgotPassword: builder.mutation<string, { email: string; username: string }>({
      query: (body) => ({
        url: `${notificationsBaseUrl}/forgot-password`,
        method: 'POST',
        body,
      }),
    }),
    forgotUsername: builder.mutation<string, { email: string }>({
      query: (body) => ({
        url: `${notificationsBaseUrl}/forgot-username`,
        method: 'POST',
        body,
      }),
    }),
    forwardResourceRequest: builder.mutation<string, { counties: string[]; requestId: number }>({
      query: (body) => ({
        url: `${notificationsBaseUrl}/forward-resource-request`,
        method: 'POST',
        body,
      }),
    }),
    contactSupport: builder.mutation<
      string,
      { subject: string; details: string; fullName: string; email: string; facility: string }
    >({
      query: (body) => ({
        url: `${notificationsBaseUrl}/send-contact-msg`,
        method: 'POST',
        body,
      }),
    }),
    sendPTBlast: builder.mutation<string, PTBlastPayload>({
      query: (body) => ({
        url: `${notificationsBaseUrl}/send-pt-blast`,
        method: 'POST',
        body,
        timeout: 30_000,
      }),
    }),
  }),
});

export const {
  useContactSupportMutation,
  useForgotPasswordMutation,
  useForgotUsernameMutation,
  useForwardResourceRequestMutation,
  useSendPTBlastMutation,
} = notificationsApi;
